import React, { useEffect, useState } from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Divider,
	Radio,
	RadioGroup,
	FormControlLabel,
	FormControl,
	useMediaQuery,
	useTheme,
	// Radio,
} from '@material-ui/core';
import home from '../../assets/images/home_hero_bg3.jpg';
import flight from '../../assets/images/flight.png';
import holiday_packages from '../../assets/images/holiday_packages.png';
import things_to_do from '../../assets/images/things_to_do.png';
import travel_destination_guide from '../../assets/images/travel_destination_guide.png';
import TitleText from '../../components/reusableComponents/TitleText';
import { setTrip } from '../../reducers/UiReducer';
import { useDispatch, useSelector } from 'react-redux';
import SimpleSlider from '../../components/reusableComponents/SimpleSlider';
import About from '../../components/reusableComponents/About';
import Footer from '../../components/reusableComponents/Footer';
import Login from '../../components/reusableComponents/Login';
import { fetchBannerDispatch } from '../../reducers/BannerReducer';
import { fetchCityDispatch } from '../../reducers/HomeReducer';
import Drawers from '../../components/Drawers';
import p1 from '../../assets/images/p-1.jpg';
import p2 from '../../assets/images/p-2.jpg';
import p3 from '../../assets/images/p-3.jpg';
import p4 from '../../assets/images/p-4.jpg';
import p5 from '../../assets/images/p-5.jpg';
import p6 from '../../assets/images/p-6.jpg';
import SearchForm from '../../components/reusableComponents/SearchForm';
import Header from '../../components/reusableComponents/Header';
import Typed from 'typed.js';
import OurPackageCard from '../../components/reusableComponents/OurPackageCard';
import OurServiceSection from '../../components/reusableComponents/OurServiceSection';
import SuccessModal from '../../components/reusableComponents/SuccessModal';
import ErrorModal from '../../components/reusableComponents/ErrorModal';
const drawerWidth = '20vw';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	appBar: {
		width: '85vw',
		marginLeft: drawerWidth,
		backgroundColor: '#fff',
		[theme.breakpoints.down('md')]: {
			width: '80vw',
			marginLeft: '20vw',
		},
		'@media (max-width:820px)': {
			// eslint-disable-line no-useless-computed-key
			width: '75vw',
			marginLeft: '25vw',
		},
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		[theme.breakpoints.down('md')]: {
			width: '20vw',
		},
		'@media (max-width:820px)': {
			// eslint-disable-line no-useless-computed-key
			width: '25vw',
		},
	},
	drawerPaper: {
		width: drawerWidth,
		[theme.breakpoints.down('md')]: {
			width: '20vw',
		},
		'@media (max-width:820px)': {
			// eslint-disable-line no-useless-computed-key
			width: '25vw',
		},
	},
	// necessary for content to be below app bar
	toolbar: theme.mixins.toolbar, //
	drawerLogo: {
		minHeight: 110,
		display: 'flex',
		alignItems: 'center',
		'@media (max-width:820px)': {
			// eslint-disable-line no-useless-computed-key
			minHeight: 167,
		},
	},
	content: {
		flexGrow: 1,
		// backgroundColor: theme.palette.background.default,
		backgroundColor: '#F5F7FF',
		padding: theme.spacing(5),
		minHeight: '100vh',
		width: '83vw',
		[theme.breakpoints.down('md')]: {
			width: '78vw',
		},
		'@media (max-width:820px)': {
			// eslint-disable-line no-useless-computed-key
			width: '73vw',
		},
	},
	custom: {
		flexDirection: 'column',
		alignItems: 'flex-start',
		color: theme.palette.text.primary,
	},
	drawerIcon: {
		minWidth: 40,
	},
	menuItem: {
		backgroundColor: '#fff',
	},
	selectedMenuItem: {
		backgroundColor: '#f2f5fe',
	},
	menuText: {
		color: '#000',
		fontWeight: 600,
	},
	selectedMenuText: {
		color: '#0035F0',
		fontWeight: 600,
	},
	logout: {
		position: 'absolute',
		bottom: 10,
	},
	filterSortWrapper: {
		paddingLeft: 50,
		paddingRight: 50,
		paddingTop: 8,
		paddingBottom: 8,
		[theme.breakpoints.down('md')]: {
			paddingLeft: 10,
			paddingRight: 10,
		},
	},
	filterSortButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
		backgroundColor: '#F0F3FF',
		padding: theme.spacing(1.25, 1.5),
		borderRadius: 25,
		'&:hover': { backgroundColor: '#F0F3FF' },
	},
	searchBar: {
		'&&&:before': {
			borderBottom: 'none',
		},
	},
	filterGrid: {
		'@media (max-width:1100px)': {
			// eslint-disable-line no-useless-computed-key
			maxWidth: 'none',
			flexBasis: 'auto',
		},
		paddingLeft: '5px',
		paddingRight: '5px',
		'@media (max-width:820px)': {
			padding: '4px 3px',
		},
	},
	headerBox: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '10px 40px',
		},
	},
	back: {
		backgroundImage: `url(${home})`,
		height: 967,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: '1px -323px',
		position: 'relative',
		[theme.breakpoints.up('lg')]: {
			height: 494,
		},
		[theme.breakpoints.down('xs')]: {
			height: 1144,
		},
	},
	radio: {
		'& .MuiRadio-root': {
			color: 'white',
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#f50057',
		},
		'& .MuiTypography-body1': {
			color: 'white',
			fontSize: 16,
			fontFamily: 'Lato',
		},
	},
}));
const data2 = [
	{
		title: 'Mumbai',
		image: p1,
		price: '₹22999',
		discount: '₹18999',
		desc: 'The mega-glamorous capital city of Maharashtra. Mumbai Tour Packages introduce visitors to the mega-city snuggled along the Arabian Sea, driven by power, wealth, glamour and fame. The megapolis is thriving with dreams and aspirations.',
	},
	{
		title: 'Hawaii',
		image: p2,
		price: '₹145999',
		discount: '₹136999',
		desc: 'The perfect example of an island paradise, Hawaii stands out for its beautiful landscapes, gorgeous beaches and a vibrant culture. Situated in the Central Pacific Ocean, Hawaii is a group of volcanic islands, visited by millions of tourists every year',
	},
	{
		title: 'Sydney',
		image: p3,
		price: '₹95999',
		discount: '₹85999',
		desc: 'Sydney, the capital of New South Wales in Australia, is one of the oldest and largest cities in the country that has a multicultural outlook. Famous for the iconic landmarks like Sydney Harbour Bridge and Sydney Opera House, this place is simply worth a visit.',
	},
	{
		title: 'Paris',
		image: p4,
		price: '₹155999',
		discount: '₹145999 ',
		desc: 'Paris, the stylish French capital, conjures up images of monument-lined boulevards, waterside boutiques and bistros, museums, art galleries, eclectic wine bars, reading cafes, designer outlets, primly manicured gardens, and the ubiquitous Eiffel Tower.',
	},
	{
		title: 'Tokyo',
		image: p5,
		price: '₹65999',
		discount: '₹55999 ',
		desc: 'Tokyo is in the Kanto region of Japan on the south coast of the main island and is the country capital city. It is a foodie"s paradise, haven of pop culture, and has the highest urban population in the world with nearly 38 million people living in Tokyo alone.',
	},
	{
		title: 'Egypt',
		image: p6,
		price: '₹95999',
		discount: '₹82999 ',
		desc: 'Egypt strategic location in the northeast of Africa with the Mediterranean Sea to its north, the Red Sea, the Gulf of Suez and the Gulf of Aqaba to its east and an eastern portion, the Sinai Peninsula, falling in Western Asia, makes it a significant country in the Arab world aside .',
	},
];
const dataService = [
	{
		id: 1,
		title: 'Affordable Hotels Booking',
		fontawesomeIcon: 'fas fa-hotel',
		desc: 'We offer the easiest hotel reservation services for you to take advantage of. Avail the best prices and check out accurate hotel listings in India and abroad',
	},
	{
		id: 2,
		title: 'Fastest Travel Booking',
		fontawesomeIcon: 'fas fa-plane',
		desc: 'Book Your Flight And Train Tickets Online Without Going Through Any Hassle. Check Availability Of Seats, Schedule And Compare Fares For Both Domestic As Well As Foreign Travel.',
	},
	{
		id: 3,
		title: 'Bus Booking',
		fontawesomeIcon: 'fas fa-bus',
		desc: 'A bus reservation system is a mobile or web software solution designed to provide customers with a personalized easy-to-utilize user experience for booking and purchasing tickets online.',
	},

	{
		id: 4,
		title: 'Car Booking',
		fontawesomeIcon: 'fas fa-car',
		desc: 'Our car rental system is a web-based booking system intended to meet the particular needs of car rental organizations, travel consolidators, and travel agents.',
	},
	{
		id: 5,
		title: 'New adventures',
		fontawesomeIcon: 'fas fa-hiking',
		desc: 'Tour Packages are one of the best ways to travel hassle-free. With seamless planning, arrangements, and transfers being taken care of, booking tour packages from india is the best way to explore the world’s varied landscapes.',
	},
	{
		id: 6,
		title: 'Holiday Package',
		fontawesomeIcon: 'fas fa-globe',
		desc: 'Tour Packages are one of the best ways to travel hassle-free. With seamless planning, arrangements, and transfers being taken care of, booking tour packages from india is the best way to explore the world’s varied landscapes.',
	},
];
const Home = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { drawer, trip } = useSelector((state) => state.ui);
	const [data, setData] = useState(false);
	const [value, setValue] = useState('Economy');
	const [adult, setAdult] = useState(0);
	const [child, setChild] = useState(0);
	const [infant, setInfant] = useState(0);
	const theme = useTheme();

	const handleChange = (event) => {
		setValue(event.target.value);
	};
	useEffect(() => {
		dispatch(fetchBannerDispatch());
		dispatch(fetchCityDispatch());
	}, []);
	const matches = useMediaQuery(theme.breakpoints.down('xs'));
	const matches2 = useMediaQuery(theme.breakpoints.down('sm'));
	const el = React.useRef(null);
	// Create reference to store the Typed instance itself
	const typed = React.useRef(null);
	// React.useEffect(() => {
	// 	const options = {
	// 		strings: [
	// 			'Book Flights Tickets, Tour Packages, Hotels & Sightseeing',
	// 			'Welcome to Musafirbazar for B2B!',
	// 			// 'Some <strong>strings</strong> are bold',
	// 			// 'HTML characters &times; &copy;',
	// 		],
	// 		typeSpeed: 100,
	// 		backSpeed: 100,
	// 		loop: true,
	// 	};

	// 	// elRef refers to the <span> rendered below
	// 	typed.current = new Typed(el.current, options);

	// 	// return () => {
	// 	// 	// Make sure to destroy Typed instance during cleanup
	// 	// 	// to prevent memory leaks
	// 	// 	typed.current.destroy();
	// 	// };
	// }, []);
	const handleChange2 = (e) => {
		console.log(e.target.value);
		dispatch(setTrip(e.target.value));
	};
	return (
		<>
			<Box
				style={{
					paddingTop: '10px',
					background: 'linear-gradient(180deg,rgb(0 0 0/52%),rgb(0 0 0/0))',
					position: 'absolute',
					zIndex: 99,
					height: 60,
					top: 0,
					right: 0,
					bottom: 0,
					left: 0,
				}}>
				<Container>
					<Header />
					<Box textAlign='center' style={{ color: 'white' }} mt={'100px'}>
						<marquee>
							<p
								// ref={el}
								// four
								style={{
									fontFamily: 'Roboto Serif, sans-serif',
									fontSize: 26,
									fontWeight: 700,
								}}>
								Book Flights Tickets, Tour Packages, Hotels & Sightseeing
							</p>
						</marquee>
					</Box>

					<Grid container style={{ marginTop: 20 }}>
						<Grid item xs={1} style={{ maxWidth: 'none' }}>
							<Box
								display='flex'
								justifyContent='space-around'
								style={{
									backgroundColor: '#39c9bb',
									color: 'white',
									padding: '8px 25px',
									textAlign: 'center',
									width: '100%',
								}}>
								<i class='fa-solid fa-plane'></i>
								<TitleText
									three
									textStyle={{
										fontFamily: 'Roboto Serif, sans-serif',
										marginLeft: 10,
									}}>
									Flight
								</TitleText>
							</Box>
						</Grid>

						<Box className={classes.radio} ml={'20px'}>
							<FormControl onChange={handleChange2}>
								<RadioGroup
									row
									aria-labelledby='demo-row-radio-buttons-group-label'
									name='row-radio-buttons-group'>
									<FormControlLabel
										value='onetrip'
										control={
											<Radio checked={trip == 'onetrip' ? true : false} />
										}
										label='OneWay'
									/>
									<FormControlLabel
										value='roundtrip'
										control={<Radio />}
										label='RoundTrip'
									/>
								</RadioGroup>
							</FormControl>
						</Box>
					</Grid>
					<SearchForm />
					<Grid
						container
						alignItems='center'
						className='shadow'
						style={{
							backgroundColor: 'white',
							height: matches ? '18rem' : matches2 ? '10rem' : '6rem',
							borderRadius: 50,
							paddingLeft: 70,
							paddingTop: 10,
							// paddingBottom: 10,
							marginTop: 163,
							width: '100%',
						}}>
						<Grid item xs={12} sm={6} md={3} lg={3}>
							<Box display='flex' alignItems='center'>
								<img src={flight}></img>
								<TitleText
									three
									textStyle={{
										marginLeft: 10,
										fontFamily: 'Roboto Serif, sans-serif',
										fontWeight: 600,
									}}>
									Flights
								</TitleText>
							</Box>
						</Grid>
						<Grid item xs={12} sm={6} md={3} lg={3}>
							<Box display='flex' alignItems='center'>
								<img src={holiday_packages}></img>
								<TitleText
									three
									textStyle={{
										marginLeft: 10,
										fontFamily: 'Roboto Serif, sans-serif',
									}}>
									Holiday Packages
								</TitleText>
							</Box>
						</Grid>
						<Grid item xs={12} sm={6} md={3} lg={3}>
							<Box display='flex' alignItems='center'>
								<img src={travel_destination_guide}></img>
								<TitleText
									three
									textStyle={{
										marginLeft: 10,
										fontFamily: 'Roboto Serif, sans-serif',
									}}>
									Travel Destination Guide
								</TitleText>
							</Box>
						</Grid>
						<Grid item xs={12} sm={6} md={3} lg={3}>
							<Box display='flex' alignItems='center'>
								<img src={things_to_do}></img>
								<TitleText
									three
									textStyle={{
										marginLeft: 10,
										fontFamily: 'Roboto Serif, sans-serif',
									}}>
									Things To Do
								</TitleText>
							</Box>
						</Grid>
					</Grid>
					<SimpleSlider value={'Holiday'} />
				</Container>
				<Box style={{ backgroundColor: 'lightgrey' }}>
					<Container style={{ paddingTop: 5, paddingBottom: 60 }}>
						{/* <SimpleSlider value={'Flight'} /> */}
						{/* <TrendingSlider value={'Flight'} /> */}
					</Container>
				</Box>
				<Box
					style={{
						background: 'linear-gradient(180deg,#020f23,#19212e)',
					}}>
					{/* <div>
						<div
							style={{
								position: 'absolute',
								borderRadius: '50px',
								opacity: 0.19,
								width: 100,
								height: 100,
								left: '-50px',
								// top: '15px',
								background: 'teal',
							}}></div>
						<div
							style={{
								left: 0,
								marginTop: 497,
								position: 'absolute',
								background: '#f56d6d',
								borderRadius: '50px',
								opacity: 0.18,
								width: 100,
								height: 100,
							}}></div>
						<div
							style={{
								left: '50%',
								// top: '-40px',
								transform: 'translate(-50%)',
								position: 'absolute',
								background: '#f56d6d',
								borderRadius: '50px',
								opacity: 0.18,
								width: '80px',
								height: '80px',
							}}></div>
						<div
							style={{
								position: 'absolute',
								// right: -50,
								width: 100,
								height: 100,
								// bottom: '25%',
								marginTop: '11%',
								marginLeft: '91%',
								background: '#39c9bb',
								opacity: 0.18,
								transform: 'rotate(45deg)',
							}}></div>
					</div> */}
					<Container style={{ paddingTop: 5, paddingBottom: 60 }}>
						<SimpleSlider value={'Package'} />
					</Container>
				</Box>
				<section className='packages' id='packages'>
					<h1
						className='heading'
						style={{ fontFamily: 'unset', textAlign: 'left' }}>
						Travel <span>Destination</span>
					</h1>

					<div className='box-container'>
						{data2.map((item, index) => {
							return <OurPackageCard item={item} index={index} />;
						})}
					</div>
				</section>

				<section className='services' id='services'>
					<h1 className='heading'>
						We <span>Deals In</span>
					</h1>

					<div className='box-container'>
						{dataService.map((item, index) => {
							return <OurServiceSection item={item} index={index} />;
						})}
					</div>
				</section>
				<Box mt={'30px'}>
					{/* <Container>
						<ExploreTravel />
					</Container> */}
				</Box>
				<Box mt={'30px'}>
					{/* <Container>
						<ProductOffer />
					</Container> */}
				</Box>
				<Box mt={'30px'}>
					<Divider />
					<Container>
						<About />
					</Container>
				</Box>
				<Box
					mt={'30px'}
					style={{ backgroundColor: '#2c3544', padding: '1.25rem' }}>
					<Footer />
					{/* <div
						style={{
							position: 'absolute',
							top: '-20px',
							left: '50%',
							transform: 'translateX(-50%)',
							width: '162px',
							height: '100px',
							cursor: 'pointer',
							textAlign: 'center',
						}}></div>  */}
				</Box>
			</Box>
			<Box className={classes.back} style={{}}></Box>

			<div>
				<Drawers />
				<Login />
			</div>
			<SuccessModal />
			<ErrorModal />
		</>
	);
};

export default Home;
